<template>
	<div class="relations-container">
		<div class="relations-container__section-header">
			<div class="relations-container__section-title">Relations</div>
			<Button
				v-if="!readonly"
				icon="fal fa-plus"
				label="New Relation"
				severity="secondary"
				@click="newRelation" />
		</div>
		<Relation
			v-for="relation in Object.values(module.model.relations)"
			:key="relation.name"
			:inverse-module="app.moduleRegistry.get(relation.model)!"
			:module="module"
			:readonly
			:relation
			@delete="handleDeleteRelation(relation)" />
		<NewRelationForm
			v-if="module && app"
			:key="module.name!"
			v-model:visible="newRelationFormOpen"
			:app
			:module
			@create="handleSaveRelation" />
	</div>
</template>

<script setup lang="ts">
import type { EnrichedApp } from '@codecannon/schemas/schemas/EnrichedApp'
import type { EnrichedModule } from '@codecannon/schemas/schemas/EnrichedModule'
import Relation from './RelationsContainer/Relation.vue'
import { useConfirm } from 'primevue'
import type { EnrichedRelation } from '@codecannon/schemas/schemas/EnrichedRelation'
import Button from 'primevue/button'
import NewRelationForm from './RelationsContainer/NewRelationForm.vue'
import { ref } from 'vue'

const emit = defineEmits<{
	(e: 'update'): void
}>()

const props = defineProps<{
	app: EnrichedApp
	module: EnrichedModule
	readonly: boolean
}>()

const confirm = useConfirm()
const newRelationFormOpen = ref(false)

function newRelation() {
	newRelationFormOpen.value = true
}

function handleSaveRelation(params: { relation: EnrichedRelation; inverse: EnrichedRelation }) {
	newRelationFormOpen.value = false
	props.module.addRelation({ ...params, skipForeignKey: true })
	emit('update')
}

async function handleDeleteRelation(relation: EnrichedRelation) {
	confirm.require({
		message: `Are you sure you want to delete the ${relation.name} relation?`,
		header: 'Danger Zone',
		icon: 'fas fa-exclamation-triangle',
		rejectLabel: 'Cancel',
		rejectProps: {
			label: 'Cancel',
			severity: 'secondary',
			outlined: true,
		},
		acceptProps: {
			label: 'Delete',
			severity: 'danger',
		},
		accept: async () => {
			props.module.removeRelation(relation.name)
			emit('update')
		},
		reject: () => {},
	})
}
</script>

<style lang="scss" scoped>
.relations-container {
	.relations-container__section-header {
		display: flex;
		align-items: space-between;
		width: 100%;
		margin-bottom: 10px;
		height: 42px;

		.relations-container__section-title {
			display: flex;
			align-items: center;
			font-size: 22px;
			flex: 1;
		}
	}
}
</style>
